export const queryKeys = {
    AUTH_USER: 'auth-user',
    AuthRoles: 'AuthRoles',
    AUTH_PROVIDERS: 'auth-provider',
    ORGANISATION: 'organisation',
    ORGANISATIONS: 'organisations',
    ORGANISATION_TYPE: 'organisation-type',
    ORGANISATION_TYPES: 'organisation-types',
    SUPPORT_TYPE: 'support-type',
    SUPPORT_TYPES: 'support-types',
    USERS: 'users',
    USER: 'user',
    ROLES: 'roles',
    USER_ROLES: 'user-roles',
    REFERRAL_ORGANISATION: 'referral-organisation',
    REFERRAL_ORGANISATIONS: 'referral-organisations',
    CUSTOM_ATTRIBUTE_CONFIGURATIONS: 'custom-attribute-configurations',
    CUSTOM_ATTRIBUTE_CONFIGURATION: 'custom-attribute-configuration',
    CARD_SETS: 'card_sets',
    CARD_SET: 'card_set',
    REGISTRATIONS: 'registrations',
    SUPPORT_TYPES_FREQUENCIES: 'support-types-frequencies',
    SUPPORT_TYPES_FREQUENCY: 'support-types-frequency',
    INCOME_TYPES: 'income-types',
    INCOME_TYPE: 'income-type',
    EXPENSE_TYPES: 'expense-types',
    EXPENSE_TYPE: 'expense-type',
    FOOD_RESTRICTIONS: 'food-restrictions',
    FOOD_RESTRICTION: 'food-restriction',
    DASHBOARDS: 'DASHBOARDS',
    REPORT: 'report',
    REPORT_RESULT: 'report_result',
    COMMENTS: 'comments',
    SUPPORT_CASE: 'support-case',
    SUPPORT_CASES: 'support-cases',
    SUPPORT_CASE_INFO: 'support-case-info',
    SUPPORT_CASES_DUPLICATES: 'support-cases-duplicates',
    SUPPORT_PERIODS: 'support-periods',
    INTAKES: 'intakes',
    INTAKE: 'intake',
};
